import { render, staticRenderFns } from "./AutosuggestInstance.vue?vue&type=template&id=2fd19805"
import script from "./AutosuggestInstance.vue?vue&type=script&lang=js"
export * from "./AutosuggestInstance.vue?vue&type=script&lang=js"
import style0 from "./AutosuggestInstance.vue?vue&type=style&index=0&id=2fd19805&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports